import { createReducer, INITIAL_STATE } from '@shared/redux';

export const CONFIRM_FORGOT_PASSWORD_SUBMITTED = '@auth/CONFIRM_FORGOT_PASSWORD_SUBMITTED';
export const CONFIRM_FORGOT_PASSWORD_ACCEPTED = '@auth/CONFIRM_FORGOT_PASSWORD_ACCEPTED';
export const CONFIRM_FORGOT_PASSWORD_REJECTED = '@auth/CONFIRM_FORGOT_PASSWORD_REJECTED';
export const CONFIRM_FORGOT_PASSWORD_VALIDATE_PASSWORD = '@auth/CONFIRM_FORGOT_PASSWORD_VALIDATE_PASSWORD';
export const CONFIRM_FORGOT_PASSWORD_VALIDATE_CONFIRM_PASSWORD = '@auth/CONFIRM_FORGOT_PASSWORD_VALIDATE_CONFIRM_PASSWORD';
export const CONFIRM_FORGOT_PASSWORD_HANDLE_FIELDS_ERRORS = '@auth/CONFIRM_FORGOT_PASSWORD_HANDLE_FIELDS_ERRORS';

export const isConfirmForgotPasswordLoading = state => state.auth.confirmForgotPassword.loading;
export const getConfirmForgotPasswordError = state => state.auth.confirmForgotPassword.error;

export const submitConfirmForgotPassword = ({
    username,
    code,
    password,
    confirmPassword,
}) => ({
    type: CONFIRM_FORGOT_PASSWORD_SUBMITTED,
    payload: {
        username,
        code,
        password,
        confirmPassword,
    },
});

export const acceptConfirmForgotPassword = ({ user }) => ({
    type: CONFIRM_FORGOT_PASSWORD_ACCEPTED,
    payload: { user },
});

export const rejectConfirmForgotPassword = ({ code, error }) => ({
    type: CONFIRM_FORGOT_PASSWORD_REJECTED,
    payload: { code, error },
});

export const validatePassword = ({ password, confirmPassword, error }) => ({
    type: CONFIRM_FORGOT_PASSWORD_VALIDATE_PASSWORD,
    payload: { password, confirmPassword, error },
});

export const validateConfirmPassword = ({ password, confirmPassword, error }) => ({
    type: CONFIRM_FORGOT_PASSWORD_VALIDATE_CONFIRM_PASSWORD,
    payload: { password, confirmPassword, error },
});

export const handleFieldsErrors = ({ error }) => ({
    type: CONFIRM_FORGOT_PASSWORD_HANDLE_FIELDS_ERRORS,
    payload: { error },
});

const handleErrors = (state, action) => ({
    ...state,
    error: action.payload.error,
});

export const confirmForgotPasswordReducer = createReducer({
    [INITIAL_STATE]: {
        loading: false,
        error: null,
    },

    [CONFIRM_FORGOT_PASSWORD_SUBMITTED]: state => ({ ...state, loading: true }),
    [CONFIRM_FORGOT_PASSWORD_ACCEPTED]: state => ({ ...state, loading: false }),
    [CONFIRM_FORGOT_PASSWORD_REJECTED]: (state, action) => ({
        ...state,
        loading: false,
        error: action.payload.error,
    }),
    [CONFIRM_FORGOT_PASSWORD_VALIDATE_PASSWORD]: handleErrors,
    [CONFIRM_FORGOT_PASSWORD_VALIDATE_CONFIRM_PASSWORD]: handleErrors,
    [CONFIRM_FORGOT_PASSWORD_HANDLE_FIELDS_ERRORS]: handleErrors,
});
